/**
 * @module modules/keyboard-shortcuts-help-sk
 * @description A dialog that displays registered keyboard shortcuts.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "KeyboardShortcutsHelpSk", {
    enumerable: true,
    get: function() {
        return KeyboardShortcutsHelpSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _keyboardshortcuts = require("../common/keyboard-shortcuts");
const _dialog = require("@material/web/dialog/dialog.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let KeyboardShortcutsHelpSk = class KeyboardShortcutsHelpSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <md-dialog id="help-dialog">
        <div slot="headline">Keyboard Shortcuts</div>
        <div slot="content">
          <table class="shortcuts-table">
            ${this.renderShortcuts()}
          </table>
        </div>
        <div slot="actions">
          <button @click=${()=>this.close()}>Close</button>
        </div>
      </md-dialog>
    `;
    }
    renderShortcuts() {
        const registry = _keyboardshortcuts.ShortcutRegistry.getInstance();
        const shortcuts = registry.getShortcuts();
        const rows = [];
        shortcuts.forEach((list, category)=>{
            const relevantShortcuts = list.filter((s)=>!this.handler || !s.method || typeof this.handler[s.method] === 'function');
            if (relevantShortcuts.length > 0) {
                rows.push((0, _lit.html)`
          <tr>
            <td colspan="2" class="category-header">${category}</td>
          </tr>
        `);
                relevantShortcuts.forEach((shortcut)=>{
                    rows.push((0, _lit.html)`
            <tr>
              <td class="key-cell">${shortcut.key}</td>
              <td>${shortcut.description}</td>
            </tr>
          `);
                });
            }
        });
        return rows;
    }
    open() {
        var _this_dialog;
        this.requestUpdate();
        (_this_dialog = this.dialog) === null || _this_dialog === void 0 ? void 0 : _this_dialog.show();
    }
    close() {
        var _this_dialog;
        (_this_dialog = this.dialog) === null || _this_dialog === void 0 ? void 0 : _this_dialog.close();
    }
    constructor(...args){
        super(...args);
        this.handler = null;
    }
};
_ts_decorate([
    (0, _decorators.query)('#help-dialog'),
    _ts_metadata("design:type", typeof _dialog.MdDialog === "undefined" ? Object : _dialog.MdDialog)
], KeyboardShortcutsHelpSk.prototype, "dialog", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], KeyboardShortcutsHelpSk.prototype, "handler", void 0);
KeyboardShortcutsHelpSk = _ts_decorate([
    (0, _decorators.customElement)('keyboard-shortcuts-help-sk')
], KeyboardShortcutsHelpSk);
